module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjcwNSA5LjY2ODc0SDUuMjk1TDMuOTYxNjcgMTMuMDAyMUgyLjE2NjY3TDcuMTY2NjcgMC41MDIwNzVIOC44MzMzM0wxMy44MzMzIDEzLjAwMjFIMTIuMDM4M0wxMC43MDUgOS42Njg3NFpNMTAuMDM4MyA4LjAwMjA4TDggMi45MDYyNEw1Ljk2MTY3IDguMDAyMDhIMTAuMDM4M1pNMC41IDE0LjY2ODdIMTUuNVYxNi4zMzU0SDAuNVYxNC42Njg3WiIgZmlsbD0iIzZBNzM3RCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/type-text.svg
// module id = 639
// module chunks = 11